import { render, staticRenderFns } from "./BookingItemsStats.vue?vue&type=template&id=07d3600c&scoped=true&lang=pug&"
import script from "./BookingItemsStats.vue?vue&type=script&lang=ts&"
export * from "./BookingItemsStats.vue?vue&type=script&lang=ts&"
import style0 from "./BookingItemsStats.vue?vue&type=style&index=0&id=07d3600c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d3600c",
  null
  
)

export default component.exports